import { getLeadsPage } from "../../../../helper/leadResponse";
import leadManagementThunkActions from "./leadManagementThunk";

function createExtraReducers() {
  return {
    ...getCustomerData(),
    ...getCategoryBrandData(),
    ...getReasons(),
    ...getViewLeadsData(),
    ...getDownloadData(),
    ...createLead(),
    ...updateLead(),
    ...getAttributes(),
    ...getStatus(),
  };

  function getCustomerData() {
    const { pending, fulfilled, rejected } =
      leadManagementThunkActions.getCustomerData;
    return {
      [pending]: (state) => {
        state.customerData.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.customerData = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.customerData = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function getCategoryBrandData() {
    const { pending, fulfilled, rejected } =
      leadManagementThunkActions.getCategoryBrandData;
    return {
      [pending]: (state) => {
        state.categoryBrandData.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.categoryBrandData = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.categoryBrandData = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function getReasons() {
    const { pending, fulfilled, rejected } =
      leadManagementThunkActions.getReasons;
    return {
      [pending]: (state) => {
        state.reasonData.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.reasonData = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.reasonData = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function getViewLeadsData() {
    const { pending, fulfilled, rejected } =
      leadManagementThunkActions.getViewLeadsData;
    return {
      [pending]: (state) => {
        state.viewLeadsData.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.viewLeadsData = {
          isLoading: false,
          error: null,
          data: getLeadsPage(JSON.parse(action.payload.data)?.data),
          channel: action?.meta?.arg?.channel || "",
        };
      },
      [rejected]: (state, action) => {
        state.viewLeadsData = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
          channel: action?.meta?.arg?.channel || "",
        };
      },
    };
  }
  function getDownloadData() {
    const { pending, fulfilled, rejected } =
      leadManagementThunkActions.getDownloadData;
    return {
      [pending]: (state) => {
        state.downloadData.isLoading = true;
        state.downloadData.error = null;
      },
      [fulfilled]: (state) => {
        state.downloadData = {
          isLoading: false,
          error: null,
          data: [],
        };
      },
      [rejected]: (state, action) => {
        state.downloadData = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function getDownloadData() {
    const { pending, fulfilled, rejected } =
      leadManagementThunkActions.getDownloadData;
    return {
      [pending]: (state) => {
        state.downloadData.isLoading = true;
        state.downloadData.error = null;
      },
      [fulfilled]: (state) => {
        state.downloadData = {
          isLoading: false,
          error: null,
          data: [],
        };
      },
      [rejected]: (state, action) => {
        state.downloadData = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function createLead() {
    const { pending, fulfilled, rejected } =
      leadManagementThunkActions.createLead;
    return {
      [pending]: (state) => {
        state.createLeadData.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.createLeadData = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.createLeadData = {
          isLoading: false,
          // `request` and the envelope check both reject with a plain string;
          // keep the object form as a fallback for other rejection shapes.
          error:
            action?.payload?.error ||
            (typeof action?.payload === "string" ? action.payload : "") ||
            "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function updateLead() {
    const { pending, fulfilled, rejected } =
      leadManagementThunkActions.updateLead;
    return {
      [pending]: (state) => {
        state.updateLeadData.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.updateLeadData = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.updateLeadData = {
          isLoading: false,
          error: action?.payload || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function getAttributes() {
    const { pending, fulfilled, rejected } =
      leadManagementThunkActions.getAttributes;
    return {
      [pending]: (state) => {
        state.attributes.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.attributes = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.attributes = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function getStatus() {
    const { pending, fulfilled, rejected } =
      leadManagementThunkActions.getStatus;
    return {
      [pending]: (state) => {
        state.status.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.status = {
          isLoading: false,
          error: null,
          data: JSON.parse(action.payload.data).data,
        };
      },
      [rejected]: (state, action) => {
        state.status = {
          isLoading: false,
          error: action?.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
}

const dashboardExtraReducers = createExtraReducers();
export default dashboardExtraReducers;
